import React from 'react';
import styles from './Loader.module.css';

export default function Loader({ text = 'Processando...' }) {
  return (
    <div className={styles.overlay} aria-live="polite" aria-label={text}>
      <div className={styles.box}>
        <div className={styles.spin} />
        <p>{text}</p>
      </div>
    </div>
  );
}
